/* LUGAZI BOOK - even rhythm: about two rows of drawings, then one thing that moves.
   The cone and the two figures used to sit before the slide, and love right before the spin; they move down
   between the drawings after the slide. A scene only moves while both it and its new place are below the screen,
   so nothing jumps under the reader. Remove this file (and its line in snippets/lugazi-hints.liquid) to undo. */
(function () {
  var MOVES = [['.lx-cone', '3746'], ['.lx-figs', '3761'], ['.lx-love-scene', '3779']];
  function rhythm() {
    if (document.body.dataset.lugaziView !== 'book') return;
    var moved = false, vh = innerHeight;
    MOVES.forEach(function (m) {
      var el = document.querySelector('.lw-book ' + m[0]);
      if (!el || el.dataset.lgzMoved) return;
      var p = document.querySelector('.lw-book .lw-collage-page[data-book-id="' + m[1] + '"]'), row = p && p.closest('.lw-collage-spread');
      if (!row || row.parentElement !== el.parentElement) return;
      if (el.getBoundingClientRect().top < vh || row.getBoundingClientRect().top < vh) return;
      row.after(el); el.dataset.lgzMoved = '1'; moved = true;
    });
    if (moved) setTimeout(function () { window.dispatchEvent(new Event('resize')); window.dispatchEvent(new Event('scroll')); }, 60);
  }
  var n = 0, iv = setInterval(function () { rhythm(); if (++n > 120) clearInterval(iv); }, 500);
})();
